import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Apollo} from "apollo-angular";
import {ActivatedRoute, Router} from "@angular/router";
import {get_company_event} from "./graphql/getCompanyEvents";
import CompanyEventToolbarAction from "../enums/company-event-toolbar-action";
import {delete_company_event, update_company_event_info, update_note} from "./graphql/updateCompanyEvent";
import {OutlookEventService} from "../services/outlook-event.service";
import {CurrentUserService} from "../services/current-user.service";
import {DateTimeService} from "../services/date-time.service";
import {MatDialog} from "@angular/material/dialog";
import {AddCompanyEventModalComponent} from "../components/add-company-event-modal/add-company-event-modal.component";
import {CompanyEventCalendarManagerService} from "./company-events-calendar/company-event-calendar-manager.service";
import {DatePipe} from "@angular/common";
import {ConfirmationModalComponent} from "../components/confirmation-modal/confirmation-modal.component";
import {AlertService} from "../alert/alert.service";


@Component({
    selector: 'company-events',
    templateUrl: './company-events.component.html',
    styleUrls: ['./company-events.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyEventsComponent implements OnInit {
  constructor(private apollo: Apollo, private route: ActivatedRoute, private datepipe: DatePipe, private router: Router, private companyEventCalendarManager: CompanyEventCalendarManagerService, private outlookService: OutlookEventService, private currentUserService: CurrentUserService, private dateTimeService: DateTimeService, private dialog: MatDialog, public alertService: AlertService) {
  }
  hasLoaded: boolean = false;
  companyEventId: any;
  event: any;
  y_drive:any;
  outlookEventType:any;
  outlookCalendar:any;
  attendees:any[] = []
  activeDate: any;
  outlookAttendees:any[] = []
  isOnUserCalendar: boolean = false;
  outlookEventId: string | null;
  currentUser: any;
  isEditMode:boolean = false;
  permissions: any;

  ngOnInit() {
    this.companyEventId = this.route.snapshot.paramMap.get("id")
    this.currentUserService.getUser().subscribe((user:any) => {
      this.currentUser = user;
    } );
    this.queryCompanyEvent()

  }

  queryCompanyEvent(){
    let querySubscription = this.apollo.watchQuery({
      query: get_company_event,
      variables: {
        id: this.companyEventId
      },
      fetchPolicy: 'network-only'
    }).valueChanges.subscribe(({data}) => {
      if(data){
        let response:any = data;
        this.event = response.company_event;
        this.permissions = response.me.permissionsForResource;
        this.outlookEventType = response.outlookEventTypes;
        this.outlookCalendar = response.outlookEventTypes.outlookEventTypePreference.outlookCalendar;
        this.hasLoaded = true;
        this.activeDate = this.event.companyEventDates.length >= 2 ? this.event.companyEventDates.find((date:any) => date.initial_date_time == 1) : this.event.companyEventDates[0]
        for(let i = 0; i < this.event.companyEventAttendees.length; i++){
          var attnObj = {
            ...this.event.companyEventAttendees[i],
            isOnOutlook: false
          }
          this.attendees.push(attnObj)
        }
        if(this.event.creaOutlookEvents!==null && this.event.creaOutlookEvents.length > 0) {
          this.getOutlookEvents();
        // }
        /** --- deprecated create new outlook event if no events available --- **/
        } else {
          let formatDates = this.dateTimeService.formatCompanyEventTimes(this.activeDate);
          this.createNewOutlookEvent(formatDates, [])
        }
        querySubscription.unsubscribe();

      }
    })
  }

  getOutlookEvents(){
    for(let i = 0; i < this.event.creaOutlookEvents.length; i++){
        const parameters = {
          id: this.event.creaOutlookEvents[i].outlookEvent.event_id,
          calendar: this.outlookCalendar.calendar_id,
          user: this.outlookCalendar.user_id
        }
        this.outlookEventId = parameters.id;
        this.outlookService.getOutlookEvent(parameters, (result:any) => {
          if(result.attendees!==null){
            this.outlookAttendees = result.attendees;
            for(let i = 0; i < this.attendees.length; i++){
              let hasName = this.outlookAttendees
                .filter((attn) => attn.emailAddress.name === this.attendees[i].person.name).length > 0;
              this.attendees[i].isOnOutlook = hasName;
            }
            for(let i = 0; i < result.attendees.length; i++){
              if((this.currentUser.username + '@creallc.com') === result.attendees[i].emailAddress.address ){
                this.isOnUserCalendar = true;

              }
            }
          }
        });

    }

  }

  onEventToolbarClick(event:CompanyEventToolbarAction){
    if(event===CompanyEventToolbarAction.Return){
      this.router.navigate(["/company_events/calendar"], {queryParams: {start: this.activeDate.start_date}})
    }
    if(event===CompanyEventToolbarAction.Add){
      let dialogRef = this.dialog.open(AddCompanyEventModalComponent, {
        width: "600px",
        data: {
          eventTypes: this.companyEventCalendarManager.typesList()
        }
      })
      let instance = dialogRef.componentInstance
      const dialogSaveCloseSubscription = dialogRef.componentInstance.onSaveAndClose.subscribe((data:any) => {
        let formResponse = data.formData;
        let formGroup = data.formGroup;
        this.companyEventCalendarManager.companyEventMutation(formResponse, (data) => {
          let response:any = data;
          this.companyEventCalendarManager.companyEventDateTimeMutation(formResponse, response.createCompanyEvent.id, null, (data) => {
            instance.isLoading = false;
            dialogRef.close()
          }, )
        })
      })

      const dialogSaveAndResetSubscription = dialogRef.componentInstance.onSave.subscribe((data:any) => {
        let formResponse = data.formData;
        let formGroup = data.formGroup;
        this.companyEventCalendarManager.companyEventMutation(formResponse, (data) => {
          let response:any = data;
          this.companyEventCalendarManager.companyEventDateTimeMutation(formResponse, response.createCompanyEvent.id, null, (data) => {
            instance.isLoading = false;
            formGroup.reset()
          })
        })
      })
    }
    if(event===CompanyEventToolbarAction.Outlook){
      let formatDates = this.dateTimeService.formatCompanyEventTimes(this.activeDate);
      if(this.outlookEventId==null || this.outlookEventId==undefined){
        this.alertService.add("", "Outlook not attached to this event")
        return;
      } else {
          let outlookAttendees:any = []
          for(let i=0; i < this.attendees.length; i++){
            if(this.attendees[i].isOnOutlook){
              outlookAttendees.push(this.attendees[i].person.id)
            }
          }
          if(this.isOnUserCalendar){
            outlookAttendees = outlookAttendees.filter((user:any) => user !== this.currentUser.person.id)
          } else {
            outlookAttendees.push(this.currentUser.person.id)
          }
          this.updateOutlookAttendees(outlookAttendees, true)


      }
      setTimeout(()=> {
        this.isOnUserCalendar = !this.isOnUserCalendar
        this.getOutlookEvents()
      }, 3000)

    }
    if(event === CompanyEventToolbarAction.Delete){
      let dialogRef = this.dialog.open(ConfirmationModalComponent, {
        width: '600px',
        height: '200px',
        data: {
          modalTitle: 'Delete Company Event',
          actionMessage: 'Are you sure you want to delete this company event?',
        }
      });

      dialogRef.afterClosed().subscribe((data) => {
        if(data.clicked === 'Ok'){
          this.deleteCompanyEvent()
        }
      })
    }
    return;
  }

  updateOutlookAttendees(attendees:any, attn_only?:boolean){
    let formatDates = this.dateTimeService.formatCompanyEventTimes(this.activeDate);
    /*
    If event does not yet have an outlook event; throw alert
     */
    if(this.outlookEventId==null || this.outlookEventId == undefined){
        this.alertService.add("", "Outlook not attached to this event")
        return;
    }
    let data = {
      outlook_event_type_id: this.outlookEventType.id,
      attendees: attendees,
      company_event_id: this.companyEventId,
      user: this.outlookCalendar.user_id,
      calendar: this.outlookCalendar.calendar_id,
      event_id: this.outlookEventId,
      event_datetime: formatDates,
      attendees_only: attn_only ? attn_only : false
    }

    this.outlookService.updateOutlookEvent(data, (result)=> {
      let response = result.updateGraphEvent;
      this.outlookAttendees = response.attendees;
      this.isOnUserCalendarCheck(this.outlookAttendees)
    })
  }

  updateEventInfo(updateForm:any){

    let payload = this.setUpdatePayload(updateForm)

    this.apollo.mutate({
      mutation: update_company_event_info,
      variables: {
        id: payload.event.id,
        title: payload.event.title,
        is_sponsored: payload.event.is_sponsored,
        sponsorship_amount: payload.event.sponsorship_amount,
        is_cosponsored: payload.event.is_cosponsored,
        company_event_type_id: payload.event.company_event_type_id,
        cosponsor: payload.event.cosponsor,
        is_postponed: payload.event.is_postponed,
        is_cancelled: payload.event.is_cancelled,
        notes: payload.event.notes,
        event_date_id: payload.originalTimes.event_date_id,
        start_date: payload.originalTimes.start_date,
        end_date: payload.originalTimes.end_date,
        start_time: payload.originalTimes.start_time,
        end_time: payload.originalTimes.end_time,
        timezone: payload.originalTimes.timezone,
        initial_date_time: payload.originalTimes.initial_date_time
      },
      refetchQueries: [{
        query: get_company_event,
        variables: {
          id: this.companyEventId
        }
      }],
      awaitRefetchQueries: true
    }).subscribe(({data}:any) => {
      this.activeDate = data.updateCompanyEventDate;
      if(payload.event.is_cancelled && this.outlookEventId!==null && this.outlookEventId!==undefined){
        let formatDates = this.dateTimeService.formatCompanyEventTimes(this.activeDate);
        let data = {
          outlook_event_type_id: this.outlookEventType.id,
          attendees: this.attendees,
          company_event_id: this.companyEventId,
          user: this.outlookCalendar.user_id,
          calendar: this.outlookCalendar.calendar_id,
          event_id: this.outlookEventId,
          event_datetime: formatDates,
          outlook_id: this.event.creaOutlookEvents.find((evnt:any) => this.outlookEventId == evnt.outlookEvent.event_id)?.outlookEvent.id,
          creaOutlook_id: this.event.creaOutlookEvents.find((evnt:any) => this.outlookEventId == evnt.outlookEvent.event_id)?.id
        }
        this.outlookService.cancelOutlookEvent(data, (response) => {})
        this.outlookEventId = null;
        this.isOnUserCalendar = false;
        return;
      }
      let sendUpdateInfoForOutlook = () => {
        if(this.outlookEventId!==null && this.outlookEventId!==undefined && !this.event.is_cancelled){
          let outlookAttendees:any = []
          this.attendees.filter((user) => user.isOnOutlook==true).forEach((attendee) => {
            outlookAttendees.push(attendee.person.id)
          })
          if(this.isOnUserCalendar && !outlookAttendees.includes(this.currentUser.person.id)){
            outlookAttendees.push(this.currentUser.person.id)
          }
          this.updateOutlookAttendees(outlookAttendees)
        }
      }

      if(payload.originalTimes.initial_date_time==0 && updateForm.get('postponeStartDate')!==null && updateForm.controls['postponeStartDate'].touched && this.event.companyEventDates.length<2) {
        let timesPayload = {
          "startDate": payload.postponeTimes.start_date,
          "endDate": payload.postponeTimes.end_date,
          "startTime": payload.postponeTimes.start_time,
          "endTime": payload.postponeTimes.end_time,
          "timezone": payload.postponeTimes.timezone == null ? null : typeof payload.postponeTimes.timezone == 'string' ? payload.postponeTimes.timezone : payload.postponeTimes.timezone.tz
        }
        this.companyEventCalendarManager.companyEventDateTimeMutation(timesPayload, payload.event.id, null, (result) => {
          this.activeDate = result.createCompanyEventDate
          sendUpdateInfoForOutlook()
        }, null, true);
      } else if (payload.originalTimes.initial_date_time==0 && this.event.companyEventDates.length>=2){
        let timesPayload = {
          "event_date_id": payload.postponeTimes.event_date_id,
          "startDate": payload.postponeTimes.start_date,
          "endDate": payload.postponeTimes.end_date,
          "startTime": payload.postponeTimes.start_time,
          "endTime": payload.postponeTimes.end_time,
          "timezone": payload.postponeTimes.timezone,
          "initial_date_time": payload.postponeTimes.initial_date_time
        }
        this.companyEventCalendarManager.updateCompanyEventDateTime(timesPayload, (result) => {
          this.activeDate = result.data.updateCompanyEventDate;
          sendUpdateInfoForOutlook()
        })
      } else {
        sendUpdateInfoForOutlook()
      }

      setTimeout(() => {
        this.queryCompanyEvent()
      }, 5000)

    })
  }

  createNewOutlookEvent(dates:any, attendees: any[]){

    let outlookPayload = {
      "event_type_id": this.outlookEventType.id,
      "company_event_id": this.companyEventId,
      "attendees": [...attendees],
      "event_datetime": dates,
      "outlook_calendar_id" : this.outlookCalendar.id,
      "calendar": this.outlookCalendar.calendar_id,
      "user": this.outlookCalendar.user_id
    }

    this.outlookService.createOutlookEvent(outlookPayload, (data) => {});
  }

  isOnUserCalendarCheck(outlookAttendees: any[]){
    if(outlookAttendees.length==0) this.isOnUserCalendar = false;
    for(let i = 0; i < outlookAttendees.length; i++){
      if((this.currentUser.username + '@creallc.com') === outlookAttendees[i].emailAddress.address ){
        this.isOnUserCalendar = true;
      }
    }
  }

  setUpdatePayload(formData:any){
    let strippedStartDate = this.datepipe.transform(formData.controls['startDate'].value, "yyyy-MM-dd")
    let strippedEndDate = this.datepipe.transform(formData.controls['endDate'].value, "yyyy-MM-dd")

    let strippedPostponeStartDate = formData.get('postponeStartDate') !== null && formData.controls['postponeStartDate'].value !== null ? this.datepipe.transform(formData.controls['postponeStartDate'].value) : null
    let strippedPostponeEndDate = formData.get('postponeEndDate') !== null && formData.controls['postponeEndDate'].value !== null ? this.datepipe.transform(formData.controls['postponeEndDate'].value) : null
    let rawOriginalDate = {
      start_date: strippedStartDate,
      end_date: strippedEndDate,
      start_time: formData.controls['startTime'].value == null ? null : this.dateTimeService.convertTimezoneToUTC(new Date(strippedStartDate + " " + formData.controls['startTime'].value), formData.controls['timezone'].value),
      end_time: formData.controls['endTime'].value == null ? null : this.dateTimeService.convertTimezoneToUTC(new Date(strippedStartDate + " " + formData.controls['endTime'].value), formData.controls['timezone'].value),
      timezone: formData.controls['timezone'].value
    }
    let rawPostponedDate = {
      start_date: strippedPostponeStartDate,
      end_date: strippedPostponeEndDate,
      start_time: formData.controls['postponeStartTime']?.value == null ? null : this.dateTimeService.convertTimezoneToUTC(new Date(strippedPostponeStartDate + " " + formData.controls['postponeStartTime'].value), formData.controls['postponeTimezone'].value),
      end_time: formData.controls['postponeEndTime']?.value == null ? null : this.dateTimeService.convertTimezoneToUTC(new Date(strippedPostponeStartDate + " " + formData.controls['postponeEndTime'].value), formData.controls['postponeTimezone'].value),
      timezone: formData.controls['postponeTimezone']?.value
    }
    let formattedOriginalDates = this.dateTimeService.formatCompanyEventTimes(rawOriginalDate)
    let formattedPostponeDates = formData.controls['is_postponed'].value == true && formData.controls['postponeStartDate'].value!==null ? this.dateTimeService.formatCompanyEventTimes(rawPostponedDate) : null
    let dateId = formData.controls['is_postponed'].value==true && this.event.companyEventDates.length>=2 ? this.event.companyEventDates.find((date:any) => date.initial_date_time==0).id : this.event.companyEventDates[0].id

    let originalTimes = {
      event_date_id: dateId,
      start_date: formattedOriginalDates.startDate,
      end_date: formattedOriginalDates.endDate,
      start_time: formData.controls['startTime'].value.length == 0 ? null : formattedOriginalDates.utcStart,
      end_time: formData.controls['endTime'].value.length == 0 ? null : formattedOriginalDates.utcEnd,
      timezone: formattedOriginalDates.timezone,
      initial_date_time: this.event.is_postponed || formData.controls['is_postponed'].value ? 0 : 1
    }
    let postponeTimes = {
      event_date_id: this.event.companyEventDates.find((date:any) => date.initial_date_time==1)?.id,
      start_date: formattedPostponeDates?.startDate,
      end_date: formattedPostponeDates?.endDate,
      start_time: formData.get('postponeStartTime') && formData.controls['postponeStartTime'].value?.length == 0 ? null : formattedPostponeDates?.utcStart,
      end_time: formData.get('postponeEndTime') && formData.controls['postponeEndTime'].value?.length == 0 ? null : formattedPostponeDates?.utcEnd,
      timezone: formattedPostponeDates?.timezone,
      initial_date_time: 1
    }
    let eventObject = {
      id: this.companyEventId,
      title: formData.controls['name'].value,
      is_sponsored: formData.controls['is_sponsored'].value,
      sponsorship_amount: formData.controls['sponsorshipAmount'].value,
      is_cosponsored: formData.controls['is_cosponsored'].value,
      company_event_type_id: formData.controls['type'].value,
      cosponsor: formData.controls['cosponsor'].value,
      is_postponed: formData.controls['is_postponed'].value,
      is_cancelled: formData.controls['is_cancelled'].value,
      notes: formData.controls['notes'].value,
    }
    let result = {
      event: eventObject,
      originalTimes: originalTimes,
      postponeTimes: postponeTimes
    }



    return result
  }


  updateNote(updateNote:string){
    this.apollo.mutate({
      mutation: update_note,
      variables: {
        id: this.companyEventId,
        notes: updateNote
      }
    }).subscribe(({data}) => {
      this.queryCompanyEvent()
      if(this.outlookEventId!==null && this.outlookEventId!==undefined){
        let outlookAttendees:any = []
        this.attendees.filter((user) => user.isOnOutlook==true).forEach((attendee) => {
          outlookAttendees.push(attendee.person.id)
        })
        if(this.isOnUserCalendar && !outlookAttendees.includes(this.currentUser.person.id)){
          outlookAttendees.push(this.currentUser.person.id)
        }
        this.updateOutlookAttendees(outlookAttendees)
      }
      setTimeout(() => {
        this.queryCompanyEvent()
      }, 5000)

    });
  }

  deleteCompanyEvent(){
    if(this.outlookEventId!==null && this.outlookEventId!==undefined){
      let formatDates = this.dateTimeService.formatCompanyEventTimes(this.activeDate);
      let data = {
        outlook_event_type_id: this.outlookEventType.id,
        attendees: this.attendees,
        company_event_id: this.companyEventId,
        user: this.outlookCalendar.user_id,
        calendar: this.outlookCalendar.calendar_id,
        event_id: this.outlookEventId,
        event_datetime: formatDates,
        outlook_id: this.event.creaOutlookEvents.find((evnt:any) => this.outlookEventId == evnt.outlookEvent.event_id)?.outlookEvent.id,
        creaOutlook_id: this.event.creaOutlookEvents.find((evnt:any) => this.outlookEventId == evnt.outlookEvent.event_id)?.id
      }
      this.outlookService.cancelOutlookEvent(data, (response) => {
        this.apollo.mutate({
          mutation: delete_company_event,
          variables: {
            id: this.companyEventId
          }
        }).subscribe((response:any) => {
          this.router.navigate(['company_events/calendar'])
        })
      })
    } else {
      this.apollo.mutate({
        mutation: delete_company_event,
        variables: {
          id: this.companyEventId
        }
      }).subscribe((response:any) => {
        this.router.navigate(['company_events/calendar'])
      })
    }

  }



}
